import { render, staticRenderFns } from "./LotesListv2.vue?vue&type=template&id=32d09d86"
import script from "./LotesListv2.vue?vue&type=script&lang=js"
export * from "./LotesListv2.vue?vue&type=script&lang=js"
import style0 from "./LotesListv2.vue?vue&type=style&index=0&id=32d09d86&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports